/**
 * External dependencies
 */
import { camelCase, upperFirst } from 'lodash';

/**
 * Internal dependencies
 */
import store from '@/store';
import { Step } from '@/utils/config/addShowModal';

/**
 * Opens add show modal with proper params.
 *
 * @param {string|undefined} plan Plan slug.
 */
const openAddShowModal = (plan) => {
    store.commit('changeUIState', {
        addShowModal: {
            visible: true,
            planSlug: plan,
            step: plan ? Step.Plans : undefined,
            useFirstShow: !! plan,
        },
    });
};

/**
 * Opens upgrade modal.
 *
 * @param {Array} params Regex matches.
 * @returns {void}
 */
const openUpgradeModal = (params) => openAddShowModal(params[1]);

const config = {
    '/add-show': openAddShowModal,
    '/upgrade-to-': {
        pattern: /upgrade-to-(\w+)/i,
        callback: openUpgradeModal,
    },
};

/**
 * Handles modal actions based on the url hash.
 *
 * @param {object}   to      Location object.
 * @param {string}   to.hash Location hash.
 * @param {string}   to.path Location path.
 * @param {object}   from    Previous location object.
 * @param {Function} next    Next action callback.
 */
export const modalsHook = ({ hash, path }, from, next) => {
    if (! store.state.user) {
        next();
        return;
    }

    if (hash) {
        const uiProperty = `is${upperFirst(camelCase(hash.replace('#', '')))}ModalVisible`;

        if (uiProperty in store.state.UIState) {
            store.commit('changeUIState', { [uiProperty]: true });
            next();
            return;
        }
    }

    let found = false;

    Object.entries(config).forEach(([key, config]) => {
        if (! path.startsWith(key)) {
            return;
        }

        const params = config.pattern ? path.match(config.pattern) : undefined;
        const callback = 'function' === typeof config ? config : config.callback;

        if ('function' === typeof callback) {
            callback(params);
            found = true;
        }
    });

    next(found ? '/' : undefined);
};
